import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {ContactForm} from "../../services/models/ContactForm";
import {ContactService} from "../../services/contact.service";
import {AlertController, LoadingController} from "@ionic/angular";
import {HttpHelperService} from "../../services/http-helper.service";

@Component({
  selector: 'app-contact-form',
  templateUrl: './contact-form.component.html',
  styleUrls: ['./contact-form.component.scss'],
})
export class ContactFormComponent implements OnInit {
  request: ContactForm = new ContactForm();
  constructor(
    private contactService: ContactService,
    private alertCtrl: AlertController,
    public httpHelper: HttpHelperService,
    private loadingCtrl: LoadingController
  ) { }

  ngOnInit() {}
  async onWyslijWiadomosc_click() {
    console.log('send');
    if (this.request.isNameValid && this.request.isEmailValid && this.request.isMobileValid && this.request.isMessageValid) {
      console.log('valid');
      const loading = await this.loadingCtrl.create();
      await loading.present();
      this.contactService.send(this.request).then(result => {
        loading.dismiss();
        this.alertCtrl.create({
          header: 'Sukces',
          message: 'Twoja wiadomość została wysłana',
          buttons: [{
            text: 'OK',
            handler: () => {
              this.request = new ContactForm();
            }
          }]
        }).then(p => p.present());
      }).catch(error => {
        loading.dismiss();
        console.log(error);
        this.alertCtrl.create({
          message: error.message,
          buttons: ['OK']
        }).then(p => p.present());
      });
    } else {
      this.alertCtrl.create({
        header: 'Błąd',
        message: 'Uzupełnij wszystkie pola formularza',
        buttons: ['OK']
      }).then(p => p.present());
    }
  }
}
